export default "__VITE_ASSET__34cfaf45__"